import * as tslib_1 from "tslib";
import { HttpClient, HttpParams } from '@angular/common/http';
var VideoRequestsService = /** @class */ (function () {
    function VideoRequestsService(http) {
        this.http = http;
        this.endpoint = 'video-requests';
    }
    VideoRequestsService.prototype.all = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.get(this.endpoint).toPromise()];
            });
        });
    };
    VideoRequestsService.prototype.get = function (requestId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.http.get(this.endpoint, {
                        params: new HttpParams().set('id', requestId)
                    }).toPromise()];
            });
        });
    };
    VideoRequestsService.prototype.put = function (videoRequest) {
        return this.http.put(this.endpoint, videoRequest);
    };
    return VideoRequestsService;
}());
export { VideoRequestsService };
